import { Component, ChangeDetectionStrategy, Inject } from '@angular/core';
import { IMPACT_OVERLAY_DATA, ImpactOverlayRef } from '@libs/overlay';
import { ReserveInStoreDialogData, ReserveInStoreEvent } from '@features/reserve-in-store/reserve-in-store';
import { ReserveInStoreFormComponent } from '../reserve-in-store-form/reserve-in-store-form.component';
import { DialogSidebarComponent } from '../../dialog/dialog-sidebar/dialog-sidebar.component';

@Component({
    selector: 'app-reserve-in-store-user-dialog',
    templateUrl: './reserve-in-store-user-dialog.component.html',
    styleUrls: ['./reserve-in-store-user-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [DialogSidebarComponent, ReserveInStoreFormComponent]
})
export class ReserveInStoreUserDialogComponent {
    constructor(
        public readonly overlayRef: ImpactOverlayRef,
        @Inject(IMPACT_OVERLAY_DATA) public data: ReserveInStoreDialogData
    ) {}

    public onUpdateEvent = (data: ReserveInStoreEvent): void => {
        if (data.event === 'CANCEL') {
            this.overlayRef.close();
            return;
        }

        this.overlayRef.close({ ...data });
    };
}
